<template>
<div class="relative">
  <div class="vx-navbar-wrapper navbar-full p-0">
    <vs-navbar class="navbar-custom navbar-skelton" :class="navbarClasses"  :style="navbarStyle" :color="navbarColor">

      <router-link to="/" custom v-slot="{ navigate }" class="vx-logo cursor-pointer mr-auto flex items-center">
        <div @click="navigate">
          <logo class="w-10 mr-4 fill-current text-primary" />
          <span class="vx-logo-text text-dark">Cohen & Aguirre</span>
        </div>
      </router-link>

      <search-bar class="mr-2"  v-if="this.initialRole === 'admin'"/>

      <change-theme class="mr-0" />

      <menu-type-layout class="mr-2" :navbarColor="navbarColor" v-if="windowWidth >= 992 && this.initialRole === 'admin'" />

      <notification-drop-down  v-if="this.initialRole === 'admin'"/>

      <profile-drop-down />

    </vs-navbar>
  </div>
</div>
</template>

<script>
import MenuTypeLayout       from './components/MenuTypeLayout.vue'
import SearchBar            from './components/SearchBar.vue'
import NotificationDropDown from './components/NotificationDropDown.vue'
import ProfileDropDown      from './components/ProfileDropDown.vue'
import ChangeTheme          from './components/ChangeTheme.vue'
import Logo                 from '../Logo.vue'

export default {
  name: 'the-navbar-horizontal',
  props: {
    logo: { type: String },
    navbarType: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      initialRole: 'public'
    }
  },
  components: {
    Logo,
    MenuTypeLayout,
    SearchBar,
    NotificationDropDown,
    ProfileDropDown,
    ChangeTheme
  },
  computed: {
    navbarColor () {
      let color = '#fff'
      if (this.navbarType === 'sticky') color = '#f7f7f7'
      else if (this.navbarType === 'static') {
        if (this.scrollY < 50) {
          color = '#f7f7f7'
        }
      }

      if (this.isThemedark === 'dark') {
        if (color === '#fff') {
          color = '#2B2B2B'
        } else {
          color = '#2B2B2B'
        }
      }

      return color
    },
    isThemedark ()          { return this.$store.state.theme                                                                       },
    navbarStyle ()          { return this.navbarType === 'static' ? {transition: 'all .25s ease-in-out'} : {}                      },
    navbarClasses ()        { return this.scrollY > 5 && this.navbarType === 'static' ? null : 'd-theme-dark-light-bg shadow-none' },
    scrollY ()              { return this.$store.state.scrollY                                                                     },
    verticalNavMenuWidth () { return this.$store.state.verticalNavMenuWidth                                                        },
    windowWidth ()          { return this.$store.state.windowWidth                                                                 }
  }, 
  created () {
    this.initialRole = 'public'
    const userRoles = JSON.parse(localStorage.getItem('userRoles'))
    if (userRoles && userRoles.some(item => item.id_role < 40)) this.initialRole = 'admin'
  }
}

</script>

